import axiosInstance from "./baseService.service";

const API_URL = "dashboard/";

const dashboardService = {
  gerarHome: async () => {
    try {
      const response = await axiosInstance.get(API_URL + "inicio");
      
      // Ensure all expected fields are defined
      const dashboardData = {
        nome: response.data.nome || '',
        profissionalId: response.data.profissionalId || '',
        profissionalNome: response.data.profissionalNome || '',
        agendamentosSemanaSemanaAtual: response.data.agendamentosSemanaSemanaAtual || 0,
        agendamentosSemanaSemanaProxima: response.data.agendamentosSemanaSemanaProxima || 0
      };
      
      return dashboardData;
    } catch (error) {
      console.error("Erro ao carregar o dashboard:", error);
      // Return a default object to prevent UI errors
      return {
        nome: '',
        profissionalId: '',
        profissionalNome: '',
        agendamentosSemanaSemanaAtual: 0,
        agendamentosSemanaSemanaProxima: 0
      };
    }
  },
};

export default dashboardService;
